import React, { useEffect, useState } from "react";
import images from "../../../Utils/importImages";
import TextField from "../Components/Inputs/TextField";
import CustomAutoComplete from "../Components/Inputs/CustomAutoComplete";
import { getCountriesData } from "../../../Redux/Apis/Global-Apis";
import CustomAutoCompleteWithImg from "../Components/Inputs/CustomAutoCompleteWithImg";
import { isValidPhoneNumber } from "libphonenumber-js";
import { sendOtp, sendOtpV2, VerifyOTPV2 } from "../../../Redux/Apis/User-Apis";
import { getLocalStorageJSON } from "../../../Utils/localStorageFunc";
import { useSelector } from "react-redux";
import { Button, CircularProgress } from "@mui/material";

function LoginDetailEdit({
  loginDetails,
  onClickCancel,
  onClickSave,
  authenticator,
}) {
  const { isUserLogin } = useSelector((state) => state.user);

  let userDC = useSelector(
    (state) => state.user.UserCurrentLocationData.dial_code
  );

  let [LoginEditDetail, setLoginEditDetail] = useState(loginDetails);

  console.log("LoginEditDetail is : ", LoginEditDetail);

  let [emailProvidedError, setEmailprovidedError] = useState("");
  let [numberProvidedError, setNumberprovidedError] = useState("");

  let [emailProvided, setEmailprovided] = useState("");
  let [numberProvided, setNumberprovided] = useState("");

  let onChnageEmail = (e) => {
    setTimer(120);
    setSendVerificationCode(false);
    setEmailprovidedError("");
    setEmailprovided(e.target.value);
  };

  let onChnagePhone = (e) => {
    setTimer(120);
    setSendVerificationCode(false);
    setNumberprovidedError("");
    setNumberprovided(e.target.value);
  };

  const [countries, setCountries] = useState([]);
  const [seletedCountry, setSelectedCountry] = useState(null);

  useEffect(() => {
    const fetchCountries = async () => {
      let data = await getCountriesData();

      if (data.length > 0) {
        let dd = data.map((item) => ({
          label: `${item.code}:${item.phone}:${item.name}`,
          value: item.phone,
          data: item,
        }));

        let usercc = dd.filter((item) => item.value == userDC);
        setSelectedCountry(usercc[0]);
        setCountries(dd);
      }
    };

    fetchCountries();
  }, []);

  let getCountryValue = (val) => {
    if (!val) return { label: "Dial Code", value: null, data: null };

    console.log("vals value herr eis : ", val);

    return {
      label: `${val.data.code}:${val.data.phone}:${val.data.name}`,
      value: val.value,
      data: val.data,
    };
  };

  let [sendVerificationCode, setSendVerificationCode] = useState(false);
  let [otp, setOtp] = useState("");
  let [otpError, setOtpError] = useState("");

  let onChangeOtp = (e) => {
    setOtp(e.target.value);
    setOtpError("");
  };

  const validateEmail = (email) => {
    if (!email) {
      setEmailprovidedError("Email is required");
      return false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        setEmailprovidedError("Invalid email address");
        return false;
      } else if (email.includes("triprizer")) {
        setEmailprovidedError("Email address not allowed");
        return false;
      } else {
        setEmailprovidedError("");
        return true;
      }
    }
  };

  const validatePhoneNumber = (phoneNumber) => {
    console.log(
      "phoneNumber, seletedCountry.data.code is : ",
      phoneNumber,
      seletedCountry.data.code
    );

    if (!phoneNumber) {
      setNumberprovidedError("*Required");
      return false;
    } else if (!isValidPhoneNumber(phoneNumber, seletedCountry.data.code)) {
      setNumberprovidedError("Invalid phone number");
      return false;
    } else {
      setNumberprovidedError("");
      return true;
    }
  };

  let onChangeCountry = (value) => {
    console.log("countrychange value si : ", value);

    setSelectedCountry(value);
  };

  const [resendLoading, setResendLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [timer, setTimer] = useState(60); // Initial timer for 60 seconds

  const handleResendClick = async (credential) => {
    if (!isResendDisabled) {
      setIsResendDisabled(true);
      setTimer(120); // Reset timer to 60 seconds
      setResendLoading(true);

      let request = {};
      request[authenticator] = credential;
      let token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");
      let res = await sendOtpV2(
        request,
        authenticator == "email"
          ? `/${LoginEditDetail.id}/send-otp/email`
          : `/${LoginEditDetail.id}/send-otp/phone`,
        token
      );

      setResendLoading(false);

      if (res.error == true) {
        setBtnLoading(false);
        setIsResendDisabled(false);
        setTimer(0); // Reset timer to 60 seconds
        setResendLoading(false);
        return { error: true };
      }
      // Countdown function
      const countdown = setInterval(() => {
        setTimer((prevTime) => {
          if (prevTime === 1) {
            clearInterval(countdown);
            setIsResendDisabled(false); // Enable after 60 seconds
          }
          return prevTime - 1;
        });
      }, 1000);
    }
  };

  let sendOtpFunc = async () => {
    console.log("seletedCountry is : ", seletedCountry);

    if (authenticator == "phone") {
      let res = validatePhoneNumber(numberProvided);

      console.log("res here inside is : ", res);

      if (res == false) {
        return;
      }
    }

    if (authenticator == "email") {
      let res = validateEmail(emailProvided);

      if (res == false) {
        return;
      }
    }

    setBtnLoading(true);

    let res = await handleResendClick(
      authenticator == "email"
        ? emailProvided
        : `${seletedCountry.value}-${numberProvided}`
    );

    if (res?.error != true) {
      setSendVerificationCode(true);
    } else {
      setSendVerificationCode(false);
    }

    setBtnLoading(false);
  };

  let verifyOtp = async () => {
    let structure = {
      identifier:
        authenticator == "email"
          ? emailProvided
          : `${seletedCountry.value}-${numberProvided}`,
      otp: otp,
      type: "register-2",
      form: authenticator,
    };

    let token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");

    setBtnLoading(true);
    let otpResp = await VerifyOTPV2(structure, LoginEditDetail.id, token);
    setBtnLoading(false);

    if (otpResp.error == true) {
      return;
    }

    // evything done
    onClickSave({
      identifier:
        authenticator == "email"
          ? emailProvided
          : `${seletedCountry.value}-${numberProvided}`,
      form: authenticator,
    });

    // setShowPassword(true);
  };

  return (
    <div className="userdb-content-right-internal-top">
      <div className="internal-tab-head">
        <h3>Login Details</h3>
        <div className="editable-profile-action">
          <div className="editable-profile-action">
            <ul class="userdb-cta-buttons">
              <li
                class="userdb-cancel-btn"
                onClick={() => onClickCancel(false)}
              >
                Cancel
              </li>
              {/* <li class="userdb-save-btn" onClick={() => saveTheData()}>
                Save
              </li> */}
            </ul>
          </div>
        </div>
      </div>
      <ul className="myprofile-general-details">
        <li style={{ display: "flex", alignItems: "baseline" }}>
          <label for="">Email</label>

          {LoginEditDetail.email == null ? (
            <TextField
              error={emailProvidedError}
              placeholder={"Enter Your Email"}
              focus={true}
              onChange={onChnageEmail}
              name="email"
              value={emailProvided}
            />
          ) : (
            <div className="myprofile-general-value">
              {LoginEditDetail.email}
            </div>
          )}
          {LoginEditDetail.auth_prime == "email" ? (
            LoginEditDetail.auth_prime_is_verified == true ? (
              <div className="myprofile-general-value">
                <span className="verifiednumber">
                  <img src={images["verified-icon.svg"]} alt="" /> Verified
                </span>
              </div>
            ) : (
              ""
            )
          ) : LoginEditDetail.non_auth_prime_is_verified == true ? (
            <div className="myprofile-general-value">
              <span className="verifiednumber">
                <img src={images["verified-icon.svg"]} alt="" /> Verified
              </span>
            </div>
          ) : (
            ""
          )}
        </li>
        <li style={{ display: "flex", alignItems: "baseline" }}>
          <label for="">Mobile No.</label>

          {LoginEditDetail.phone == null ? (
            <div style={{ display: "flex", width: "70%" }}>
              {countries.length > 0 && (
                <>
                  <CustomAutoCompleteWithImg
                    value={getCountryValue(seletedCountry)}
                    options={countries}
                    toSkip="Dial Code"
                    width="50px"
                    dropdownWidth={"150px"}
                    onChange={(value) => onChangeCountry(value)}
                  />
                  <TextField
                    error={numberProvidedError}
                    placeholder={"Enter Your Phone Number"}
                    focus={true}
                    onChange={onChnagePhone}
                    name="phone"
                    value={numberProvided}
                  />
                </>
              )}
            </div>
          ) : (
            <div className="myprofile-general-value">
              {LoginEditDetail.phone}
            </div>
          )}
          {LoginEditDetail.auth_prime == "phone" ? (
            LoginEditDetail.auth_prime_is_verified == true ? (
              <div className="myprofile-general-value">
                <span className="verifiednumber">
                  <img src={images["verified-icon.svg"]} alt="" /> Verified
                </span>
              </div>
            ) : (
              ""
            )
          ) : LoginEditDetail.non_auth_prime_is_verified == true ? (
            <div className="myprofile-general-value">
              <span className="verifiednumber">
                <img src={images["verified-icon.svg"]} alt="" /> Verified
              </span>
            </div>
          ) : (
            ""
          )}
        </li>
        {sendVerificationCode && (
          <li style={{ display: "flex", alignItems: "baseline" }}>
            <label for="">OTP : </label>

            <div
              className="myprofile-general-value"
              style={{
                display: "flex",
                width: "70%",
                justifyContent: "space-between",
              }}
            >
              <TextField
                style={{ width: "60%" }}
                error={otpError}
                placeholder={"Enter OTP"}
                focus={true}
                onChange={onChangeOtp}
                name="otp"
                value={otp}
              />

              <div
                className={`resend-otp proxima_semibold font13 ${
                  isResendDisabled ? "disabled" : "color_endeavour"
                }`}
                onClick={sendOtpFunc}
                style={{
                  padding: "5px 8px",
                  border: `1px solid ${
                    isResendDisabled ? "#B0B0B0" : "#0057B7"
                  }`,
                  cursor: isResendDisabled ? "not-allowed" : "pointer",
                  color: isResendDisabled ? "#B0B0B0" : "#0057B7",
                  textDecorationColor: isResendDisabled ? "#B0B0B0" : "#0057B7",
                }}
              >
                {resendLoading ? (
                  <CircularProgress size={18} sx={{ color: "white" }} />
                ) : (
                  `Resend OTP ${timer > 0 ? `in ${timer} sec` : ""}`
                )}
              </div>
            </div>
          </li>
        )}
        <li style={{ display: "flex", alignItems: "baseline" }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={sendVerificationCode ? verifyOtp : sendOtpFunc}
            disabled={
              authenticator == "phone"
                ? !numberProvided || !!numberProvidedError || btnLoading
                : !emailProvided || !!emailProvidedError || btnLoading
            }
            sx={{
              width: "150px",
              backgroundColor: "#0057B7",
              color: "#fff",
              fontSize: "16px",
              fontFamily: `var(--font-family-proxima_nova-semibold)`,
              // fontWeight: "600",
              marginTop: "10px",
              textTransform: "none", // Prevents uppercase transformation
              "&:hover": { backgroundColor: "#0045A5" },
              "&:disabled": {
                backgroundColor: "#B0B0B0", // Greyed-out when disabled
                color: "#fff",
                cursor: "not-allowed",
              },
            }}
          >
            {" "}
            {btnLoading ? (
              <CircularProgress size={24} sx={{ color: "white" }} />
            ) : sendVerificationCode == false ? (
              "Send OTP"
            ) : (
              "Verify"
            )}
          </Button>
        </li>
      </ul>
    </div>
  );
}

export default LoginDetailEdit;
